import { MONTHS_SHORT } from './utcDate';

const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

const pad = (value: number): string => String(value).padStart(2, '0');

const isSameLocalDay = (a: Date, b: Date): boolean => a.toDateString() === b.toDateString();

/** Reads a thread's dequeue_on, including the "2026-10-26 09:00:00+00:00" form Python's str() gives. */
export const parseDequeueOn = (value: string | null | undefined): Date | null => {
  if (!value) return null;

  const date = new Date(value.replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * When a queued thread leaves the queue, in the browser's time zone - the one the channel
 * schedule editor shows working hours in.
 */
export const formatDequeueOn = (dequeueOn: Date, now: Date = new Date()): string => {
  const time = `${pad(dequeueOn.getHours())}:${pad(dequeueOn.getMinutes())}`;

  if (isSameLocalDay(dequeueOn, now)) return `today at ${time}`;

  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);

  if (isSameLocalDay(dequeueOn, tomorrow)) return `tomorrow at ${time}`;

  const weekday = WEEKDAYS_SHORT[dequeueOn.getDay()];
  const month = MONTHS_SHORT[dequeueOn.getMonth()];

  return `${weekday}, ${month} ${dequeueOn.getDate()} at ${time}`;
};

/** The full date with the time zone, for a tooltip. */
export const formatDequeueOnFull = (dequeueOn: Date): string =>
  new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  }).format(dequeueOn);
